import {
  palette
} from "./chunk-YXYFNOAF.mjs";

// src/colors.ts
var lightColors = {
  // The app ground is pure white: white cards separate from it by shadow
  // (`theme.shadows`), not by tone, so fields and insets inside a card fill
  // with `card` / `muted`, never with `background`.
  background: palette.neutral.containerLowest,
  // #ffffff
  foreground: palette.neutral.onSurface,
  // #1c1b1f
  card: palette.neutral.containerLowest,
  // #ffffff
  cardForeground: palette.neutral.onSurface,
  // #1c1b1f
  primary: palette.primary.main,
  // #ad2f3c
  primaryForeground: palette.primary.onMain,
  // #ffffff
  primaryHover: palette.primary.onFixedVariant,
  // #8c1427
  secondary: palette.secondary.container,
  // #dee1f8
  secondaryForeground: palette.secondary.onContainer,
  // #606376
  secondaryHover: palette.secondary.fixedDim,
  // #c2c5db
  muted: palette.neutral.containerLow,
  // #f8f2f8
  mutedForeground: palette.neutral.onSurfaceVariant,
  // #584141
  /** Input placeholder text — a step lighter than mutedForeground, so a
   *  prompt never reads as typed content. */
  placeholder: palette.neutral.outline,
  // #918a8d
  border: palette.neutral.outlineVariant,
  // #e8e3e4
  /** The one edge every form field draws; `border` is too faint to hold a field on white. */
  input: "#d6d2d3",
  ring: palette.primary.main,
  // #ad2f3c
  destructive: palette.error.main,
  // #ba1a1a
  destructiveForeground: palette.error.onMain,
  // #ffffff
  destructiveHover: palette.error.onContainer,
  // #93000a
  accent: palette.neutral.containerHigh,
  // #ece6ec
  accentForeground: palette.neutral.onSurface,
  // #1c1b1f
  success: palette.tertiary.main,
  // #006d41
  successForeground: palette.tertiary.onMain,
  // #ffffff
  warning: palette.warning.main,
  // #ca8a04 warm amber
  warningForeground: palette.warning.onMain,
  // #ffffff
  /** Soft amber surface for warning-toned cards/chips. */
  warningContainer: palette.warning.container,
  // #fef9c3
  onWarningContainer: palette.warning.onContainer,
  // #713f12
  /** Soft green surface — the positive counterpart to warningContainer. */
  successContainer: palette.tertiary.fixed,
  // #71fcaf
  onSuccessContainer: palette.tertiary.onFixed,
  // #002110
  overlay: "rgba(28, 27, 31, 0.5)"
  // warm overlay
};
var darkColors = {
  background: palette.neutral.inverseSurface,
  // #322f34
  foreground: palette.neutral.inverseOnSurface,
  // #f5eff5
  card: "#3d3a3f",
  // slightly elevated dark surface
  cardForeground: palette.neutral.inverseOnSurface,
  // #f5eff5
  primary: palette.primary.inverse,
  // #ffb3b3
  primaryForeground: palette.primary.onFixedVariant,
  // #8c1427
  primaryHover: palette.primary.fixedDim,
  // #ffb3b3
  secondary: "#48465a",
  // muted secondary container (dark)
  secondaryForeground: palette.secondary.fixedDim,
  // #c2c5db
  secondaryHover: "#3a3848",
  // darker secondary hover
  muted: "#3d3a3f",
  // dark surface elevated
  mutedForeground: "#a09a9f",
  // dimmed on-surface for dark
  placeholder: "#7b757a",
  // a step dimmer than mutedForeground (dark)
  border: "#514e54",
  // dark outline variant
  input: "#48454a",
  // dark surface-variant
  ring: palette.primary.inverse,
  // #ffb3b3
  destructive: "#ffb4ab",
  // light error for dark mode
  destructiveForeground: palette.error.onContainer,
  // #93000a
  destructiveHover: "#ff897d",
  // lighter error hover
  accent: "#48454a",
  // dark elevated surface
  accentForeground: palette.neutral.inverseOnSurface,
  // #f5eff5
  success: palette.tertiary.fixedDim,
  // #51df95
  successForeground: palette.tertiary.onFixed,
  // #002110
  warning: palette.warning.dark,
  // #fde047 bright amber for dark mode
  warningForeground: palette.warning.onDark,
  // #713f12
  warningContainer: palette.warning.darkContainer,
  // #42320c
  onWarningContainer: palette.warning.onDarkContainer,
  // #fde68a
  successContainer: "#0b3a24",
  // deep green surface for dark mode
  onSuccessContainer: palette.tertiary.fixedDim,
  // #51df95
  overlay: "rgba(0, 0, 0, 0.7)"
};

export {
  lightColors,
  darkColors
};
